import {Component, Input} from '@angular/core';
import {Recipient} from '@gatewee/types/recipient';
import {Wallet} from '@gatewee/types/wallet';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'gatewee-wallet-card',
  templateUrl: './wallet-card.component.html',
  styleUrls: ['./wallet-card.component.css'],
  standalone: false,
})
export class WalletCardComponent {
  constructor(private modalService: NgbModal) {}
  @Input() wallet?: Wallet;

  @Input() withdrawal = true;

  @Input() withdrawalComponent?: Component;

  @Input() recipient?: Recipient;

  openNewWithdrawalModal(): void {
    this.modalService.open(this.withdrawalComponent, {
      size: 'lg',
    });
  }
}
